<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner file-download-inner py-2">
   
<b-card   
        v-if="files.length < 1"
          header="可供下載檔案"
          title="你未有可供下載的檔案"
          class="text-center"
          footer-class="text-muted"
        >
          <b-card-text>
          </b-card-text>
        </b-card>
<b-card   
v-for="file in files" :key="file.id"
          header="可供下載檔案"
          :title="file.file_name"
          :footer="countdown(file.expire_at)"
          class="text-center"
          footer-class="text-muted"
        >
          <b-card-text>
            <!-- {{ file.file_name }} -->
          </b-card-text>
          <b-button
            variant="outline-primary"
            @click="downloadFile(file)"
          >
            Download Now 立即下載
          </b-button>
        </b-card>
    </div>
  </div>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BLink,
  BListGroup,
  BListGroupItem,
  BOverlay,
} from 'bootstrap-vue'
  import router from '@/router'
import moment from 'moment'
export default {
  components: {
    BAlert,
    BButton,
    BCard,
    BCardText,
    router,
    BCardTitle,
    BLink,
    BListGroup,
    BListGroupItem,
    BOverlay,
  },
  data() {
    return {
      files: [],
      loading: true,
      errorMessage: '',
      now: Date.now(),
      countdownTimer: null,
    }
  },
  created() {
    this.get_file()
    this.countdownTimer = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer)
  },
  methods: {
    downloadFile(file) {
      const downloadUrl = `https://www.cloudfit.pro${file.file_url}`
      this.$http.get(downloadUrl, { responseType: 'blob' })
        .then(res => {
          const objectUrl = window.URL.createObjectURL(res.data)
          const link = document.createElement('a')
          const extension = file.file_url.match(/\.[A-Za-z0-9]+$/)
          const hasExtension = /\.[A-Za-z0-9]+$/.test(file.file_name)

          link.href = objectUrl
          link.download = file.file_name + (!hasExtension && extension ? extension[0] : '')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(objectUrl)
        })
    },
    countdown(date) {
      const secondsRemaining = Math.max(0, Math.floor((moment(date).valueOf() - this.now) / 1000))
      if (secondsRemaining === 0) return 'Expired'

      const days = Math.floor(secondsRemaining / 86400)
      const hours = Math.floor((secondsRemaining % 86400) / 3600)
      const minutes = Math.floor((secondsRemaining % 3600) / 60)
      const seconds = secondsRemaining % 60
      const time = [hours, minutes, seconds]
        .map(value => String(value).padStart(2, '0'))
        .join(':')

      return `Expire in ${days > 0 ? `${days}d ` : ''}${time}`
    },
    get_file() {
        const uuid = this.$route.params.uuid
        const timestamp = this.$route.params.timestamp
        this.$http.get(process.env.VUE_APP_API_BASE+`/file-downloads/`+uuid+`/`+timestamp+`/`)
                .then(res => {
                   this.files = res.data.files
                })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.file-download-inner {
  max-width: 620px !important;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.file-details {
  min-width: 0;
}

.file-details h6 {
  overflow-wrap: anywhere;
}

.download-button {
  flex-shrink: 0;
}

@media (max-width: 575.98px) {
  .file-item {
    display: block;
  }

  .download-button {
    width: 100%;
    margin-top: 1rem;
  }
}
</style>
